module.exports = __webpack_public_path__ + "48ee4ace1ae8a4342c093802a749559c.pdf";